<template>
  <div class="modal__content">
    <p class="text-center mb20">Are you sure you want to {{ archiveText }} this project?</p>

    <div class="flex flex--justify-center">
      <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
      <button class="btn btn--wide" @click="onConfirm">Yes</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'args' ],

    data () {
      return {}
    },

    computed: {
      archiveText () {
        return this.args.state === 'inProgress' ? 'archive' : 'unarchive'
      },

      projectState () {
        return this.args.state === 'inProgress' ? 'archived' : 'inProgress'
      }
    },

    methods: {
      onConfirm () {
        this.$bus.$emit('projectUpdateStatus', this.args.id, this.projectState)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProjectArchiveModal.vue?5738f31a